"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
// MUI components
const Select_1 = __importDefault(require("@mui/material/Select"));
const ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const InputBase_1 = __importDefault(require("@mui/material/InputBase"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
// Custom components
const themeUtils_1 = require("themes/themeUtils");
const styledComponents_1 = require("components/QuickenControls/QPopMenu/styledComponents");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useStyles = (0, mui_1.makeStyles)()(({ palette, shadows, spacing }) => ({
    formBox: {
        height: '40px',
        minWidth: 100,
    },
    accountItem: {
        padding: '4px 8px 8px 16px',
        backgroundColor: `${(0, themeUtils_1.applyOpacityToHex)(palette.background.paper, 0)} !important`,
        outline: 'none',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${palette.state.hover.default} !important`,
        },
        '&:focus': {
            border: 'none',
            outline: `2px solid ${palette.primary.main}`,
        },
        '&.selected': {
            backgroundColor: `${palette.state.hover.default} !important`,
        },
    },
    innerAccountItem: {
        display: 'flex',
        flexDirection: 'row',
    },
    accountItemNotChecked: {
        paddingLeft: '43px',
        borderRadius: '12px',
        paddingTop: '4px',
        paddingBottom: '8px',
        outline: 'none',
        backgroundColor: `${(0, themeUtils_1.applyOpacityToHex)(palette.background.paper, 0)} !important`,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${palette.state.hover.default} !important`,
        },
        '&:focus': {
            border: 'none',
            outline: `2px solid ${palette.primary.main}`,
        },
    },
    accountItemText: {
        marginBottom: -4,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        paddingRight: '5px',
        color: palette.text.primary,
    },
    root: {
        padding: 8,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        boxShadow: shadows[2],
    },
    option: {
        borderRadius: 4,
        padding: '10px 8px',
        border: 'none',
        outline: 'none',
        background: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            background: palette.background.elevated,
        },
        '&:focus': {
            background: palette.background.elevated,
        },
    },
    optionLabel: {
        lineHeight: 1,
        marginLeft: 8,
    },
    textContainer: {
        marginTop: -2,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: 15,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'center',
    },
    textBox: {
        marginTop: 2,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: 1.75,
        color: palette.text.primary,
    },
    checkIcon: {
        marginTop: 5,
        marginLeft: '3px',
        marginRight: '16px',
        color: palette.link.main,
    },
    placeholderText: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: palette.text.secondary,
    },
    formBoxSpacing: {
        margin: spacing(1),
    },
    outBasicButton: {
        border: `1px solid ${palette.border.main}`,
        borderRadius: 4,
        color: palette.text.primary,
        textTransform: 'none',
        background: 'transparent',
        '&:hover': {
            background: palette.background.subtle,
        },
    },
}));
const BootstrapInput = (0, mui_1.withStyles)(InputBase_1.default, (theme, _props) => ({
    input: {
        border: `1px solid ${theme.palette.border.default}`,
        borderRadius: 4,
        color: theme.palette.text.primary,
        textTransform: 'none',
        backgroundColor: theme.palette.surface.raised,
        '&:hover': {
            cursor: 'pointer',
            background: theme.palette.surface.raised,
        },
        '&:focus': {
            marginLeft: -1,
            border: `2px solid ${theme.palette.primary.main}`,
            backgroundColor: theme.palette.surface.raised,
        },
    },
}));
const DisabledBootstrapInput = (0, styles_1.styled)(InputBase_1.default)(({ theme }) => ({
    input: {
        border: `1px solid ${theme.palette.grey[2]}`,
        borderRadius: 4,
        color: theme.palette.text.primary,
        textTransform: 'none',
        backgroundColor: theme.palette.background.default,
    },
}));
const ReportsMenu = ({ options, onSelect, initialValue, disabled, id, disableShadow = false }) => {
    const { classes, cx } = useStyles();
    const { shadows } = (0, styles_1.useTheme)();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [menuValue, setMenuValue] = React.useState(initialValue);
    const open = Boolean(anchorEl);
    React.useEffect(() => {
        setMenuValue(initialValue);
    }, [initialValue]);
    const handleSelect = React.useCallback((e) => {
        var _a;
        const newSelectedOption = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || e;
        if (!(newSelectedOption === null || newSelectedOption === void 0 ? void 0 : newSelectedOption.custom)) {
            setMenuValue(newSelectedOption);
            onSelect(newSelectedOption);
        }
    }, [onSelect]);
    const handleClose = React.useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    }, []);
    const renderValue = React.useCallback((option) => (<div className={classes.textContainer}>
      <Typography_1.default className={classes.textBox}>{option === null || option === void 0 ? void 0 : option.label}</Typography_1.default>
    </div>), [classes]);
    return (<FormControl_1.default variant="outlined">
      <RendersCount_1.default id="newReportsMenu"/>
      <Select_1.default onOpen={(e) => { setAnchorEl(e.currentTarget); }} open={open} id={`${id}-select`} disabled={disabled} className={classes.formBox} input={disabled ? <DisabledBootstrapInput id={id}/> : <BootstrapInput id={id} shadow={disableShadow ? '' : shadows[2]}/>} value={menuValue} onClose={handleClose} IconComponent={ExpandMoreRounded_1.default} onChange={handleSelect} renderValue={renderValue}>
        {options.map((option) => option.custom ?
            <styledComponents_1.MenuItem onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.nativeEvent.stopImmediatePropagation();
                        e.stopPropagation();
                        e.preventDefault();
                        option.onClick(anchorEl);
                    }
                }} onClick={(e) => {
                    e.nativeEvent.stopImmediatePropagation();
                    e.stopPropagation();
                    e.preventDefault();
                    option.onClick(anchorEl);
                }} tabIndex={0} id={option.id} key={option.id} value={option} className={(cx(classes.accountItem, (menuValue === null || menuValue === void 0 ? void 0 : menuValue.custom) && 'selected'))}>
            <div className={classes.innerAccountItem}>
              <ListItemText_1.default classes={{ primary: classes.accountItemText }} primary={option.label}/>
            </div>
          </styledComponents_1.MenuItem>
            :
                <styledComponents_1.MenuItem onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSelect(option);
                        }
                    }} tabIndex={0} id={option.id} key={option.id} value={option} className={(cx(classes.accountItem, option.id === (menuValue === null || menuValue === void 0 ? void 0 : menuValue.id) && 'selected'))}>
            <div className={classes.innerAccountItem}>
              <ListItemText_1.default classes={{ primary: classes.accountItemText }} primary={option.label}/>
            </div>
          </styledComponents_1.MenuItem>)}
      </Select_1.default>
    </FormControl_1.default>);
};
exports.default = ReportsMenu;
